import { useBoloPanelMetadata } from '../../../../bolos/bolo-panel/state/bolo-panel-metadata-context';
import { VStack, DataList, DataItem } from '@cad-arc';
import { SectionTitle } from '../../../../fr-event-common-components/section-title';
import { formatMonthDayYearHoursMinutes } from '../../../../common/helpers/utils';

export const FrBoloDetailsTimestampsSection = () => {
    const metadata = useBoloPanelMetadata();

    if (!metadata) {
        return null;
    }

    return (
        <VStack alignItems="flex-start" gap={2}>
            <SectionTitle title="Timestamps" />
            <DataList direction="column">
                <DataItem dataKey="Init">
                    {formatMonthDayYearHoursMinutes(metadata.createdDateUtc)}
                </DataItem>
            </DataList>
            <DataList direction="column">
                <DataItem dataKey="Trans">
                    {formatMonthDayYearHoursMinutes(metadata.lastUpdatedDateUtc)}
                </DataItem>
            </DataList>
        </VStack>
    );
};
